import React, { useEffect, useState } from 'react';
import { Sparkles, RefreshCw, Crown } from 'lucide-react';
import { toast } from 'sonner';
import { api, errMsg } from '../lib/api';

export function NudgeCard({ onUpgrade }) {
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get('/nudges/latest').then((r) => setState(r.data)).catch(() => setState(null)); }, []);

  const refresh = async () => {
    setBusy(true);
    try {
      const r = await api.post('/nudges/refresh');
      setState({ locked: false, nudge: r.data.nudge });
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  if (!state) return null;
  if (state.locked) {
    return (
      <button data-testid="nudge-card-locked" onClick={onUpgrade} className="w-full mb-6 p-4 text-left rounded-xl border border-amber-500/20 bg-gradient-to-br from-[#9333EA]/10 to-amber-500/5 hover:border-amber-500/40 transition-colors duration-200">
        <div className="flex items-center gap-2 mb-1"><Sparkles className="h-4 w-4 text-amber-400" /><span className="text-xs font-bold uppercase tracking-wider text-amber-300">AI Savings Coach</span><Crown className="h-3.5 w-3.5 text-amber-400 ml-auto" /></div>
        <p className="text-sm text-[#A19DB0]">Get a personal weekly tip on how to hit each vault's goal. Included with Premium.</p>
      </button>
    );
  }
  return (
    <div data-testid="nudge-card" className="mb-6 p-5 rounded-xl border border-[#9333EA]/30 bg-[#9333EA]/[0.07]">
      <div className="flex items-center gap-2 mb-2">
        <Sparkles className="h-4 w-4 text-[#C8A6FF]" />
        <span className="text-xs font-bold uppercase tracking-wider text-[#C8A6FF]">Your savings coach</span>
        <button data-testid="nudge-refresh-btn" onClick={refresh} disabled={busy} className="ml-auto flex items-center gap-1 text-[11px] text-[#A19DB0] hover:text-white transition-colors disabled:opacity-50">
          <RefreshCw className={`h-3 w-3 ${busy ? 'animate-spin' : ''}`} />{busy ? 'Thinking…' : 'New tip'}
        </button>
      </div>
      {state.nudge ? (
        <>
          <p data-testid="nudge-title" className="text-white font-semibold">{state.nudge.title}</p>
          <p data-testid="nudge-body" className="text-sm text-[#D8D4E3] mt-1 leading-relaxed">{state.nudge.body}</p>
        </>
      ) : (
        <p data-testid="nudge-empty" className="text-sm text-[#A19DB0]">Tap "New tip" for a personal plan for your vaults. You'll also get one every Monday.</p>
      )}
    </div>
  );
}
